import React from "react";
import { Link } from "react-router-dom";

import "./HomeHero.css";

export default function HomeHero() {
  return (
    <section
      className="home-hero"
      aria-label="Academy Costumes London introduction"
    >
      <div className="home-hero__content">
        <h1 className="home-hero__title">
          40+ Years of Production Experience and Specialist Craftsmanship
        </h1>

        <p className="home-hero__lead">
          London specialists in costume production, bespoke and made-to-measure
  tailoring, jewellery hire, vintage reproduction, textiles and
  haberdashery.
        </p>

        <div className="home-hero__actions" aria-label="Homepage actions">
          <Link
            className="home-hero__cta home-hero__cta--primary"
            to="/services"
          >
            Explore Services
          </Link>

          <Link
            className="home-hero__cta home-hero__cta--secondary"
            to="/about"
          >
            About Academy Costumes London
          </Link>
        </div>

        <p className="home-hero__shop-note">
          Online shop coming soon
        </p>
      </div>

      <figure className="home-hero__media">
        <img
          src="/images/home/rusell.jpg"
          alt="Vintage menswear displayed at Academy Costumes London"
          className="home-hero__image"
          loading="eager"
          decoding="async"
        />
      </figure>
    </section>
  );
}
